<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-app id="inspire">
      <v-layout
        wrap
        justify-center
        class="login_page"
        style="background-color:white"
        :style="{
          'background-image': 'url(' + mediaURL + backgroundImage + ')',
        }"
      >
        <v-flex xs12 sm6 md4 lg3 px-2 align-self-center>
          <v-layout wrap justify-center>
            <v-flex xs112 xl10>
              <SnackBar
                v-bind:msg="msg"
                v-bind:showSnackBar="showSnackBar"
                @stepper="showSnackBar = false"
              />
              <v-card tile elevation="2">
                <v-layout wrap justify-center>
                  <v-flex xs12 px-8 pt-12 py-6>
                    <v-layout wrap justify-center>
                      <v-flex xs12 py-4 >
                         <span class="ibmsemibold large" style="color:green">KL 06</span> 
                        <!-- <v-img
                          src="./../../assets/logo.png"
                          height="20px"
                          contain
                        ></v-img> -->
                      </v-flex>
                      <v-flex xs12 pt-4>
                        <span
                          style="
                            font-family: poppinsmedium;
                            font-size: 22px;
                            color: #090909;
                          "
                          >{{ loginWithPassword ? 'Login with Password' : 'Verify with OTP' }}</span
                        >
                      </v-flex>
                      <v-flex xs12 v-if="!loginWithPassword">
                        <span
                          style="
                            font-family: poppinslight;
                            font-size: 12px;
                            color: #7b7b7b;
                          "
                          >Code is sent to
                        </span>
                        <span
                          style="
                            font-family: poppinsregular;
                            font-size: 12px;
                            color: #000;
                          "
                          >+91 {{ phone }}</span
                        >
                      </v-flex>
<v-flex
  xs12
  sm10
  md11
  lg11
  xl9
  pt-8
  d-flex
  justify-center
  align-center
  v-if="!loginWithPassword"
>                        <vie-otp-input
                          inputClasses="otp-input"
                          :numInputs="4"
                          separator
                          :shouldAutoFocus="true"
                          @on-complete="validateOTP"
                        />
                      </v-flex>

                      <!-- Password Field -->
                      <v-flex xs12 pt-6 v-else>
                        <v-text-field
                          v-model="password"
                          label="Enter Password"
                          :type="showPassword ? 'text' : 'password'"
                          outlined
                          dense
                          hide-details
                          color="#3EA56E"
                          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                          @click:append="showPassword = !showPassword"
                          class="password-field"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12 pt-4>
                        <v-layout wrap>
                          <v-flex xs12 text-center v-if="!loginWithPassword">
                            <span
                              style="
                                font-family: poppinslight;
                                font-size: 12px;
                                color: #7b7b7b;
                              "
                              >Didn't receive code? &nbsp;</span
                            >

                            <span
                              v-if="!otpexpired"
                              style="
                                font-family: poppinsmedium;
                                font-size: 12px;
                                color: #393c4a;
                              "
                              >Please Wait {{ timeLeft }}</span
                            >
                            <span
                              v-if="otpexpired"
                              style="
                                font-family: poppinsmedium;
                                font-size: 12px;
                                color: #393c4a;
                                cursor: pointer;
                              "
                              @click="sentOTP"
                              >Request again</span
                            >
                          </v-flex>
                          
                          <v-flex xs12 text-center pt-2>
                            <span
                              style="
                                font-family: poppinsmedium;
                                font-size: 13px;
                                color: #3EA56E;
                                cursor: pointer;
                                text-decoration: underline;
                              "
                              @click="loginWithPassword = !loginWithPassword"
                            >
                              {{ loginWithPassword ? 'Login with OTP' : 'Login with Password' }}
                            </span>
                          </v-flex>
                        </v-layout>
                        <v-layout v-if="msg2" py-4 wrap>
                          <v-flex text-center>
                            <span
                              style="
                                font-family: poppinslight;
                                font-size: 14px;
                                color: red;
                              "
                              >{{ msg2 }}</span
                            >
                          </v-flex>
                        </v-layout>
                      </v-flex>

                      <v-flex xs12 pt-8>
                        <v-btn
                          block
                          tile
                          color="#3EA56E"
                          dark
                          :ripple="false"
                          depressed
                          @click="validateInput"
                        >
                          <span
                            style="
                              font-family: poppinssemibold;
                              font-size: 12px;
                              text-transform: none;
                            "
                            >Continue</span
                          >
                        </v-btn>
                      </v-flex>
                      <v-flex py-12>
                        <span style="color: #fff">.</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-app>
  </div>
</template>
<script>
import VieOtpInput from "@bachdgvn/vue-otp-input";
import axios from "axios";
export default {
  components: {
    VieOtpInput,
  },
  props: ["pageData", "lastPage", "backgroundImage"],
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      msg2: null,
      phone: null,
      otp: null,
      timeLeft: "00:00",
      intervalTimer: null,
      otpexpired: false,
      loginWithPassword: false,
      password: "",
      showPassword: false,
    };
  },
  beforeMount() {
    this.setTime(180);
    this.phone = this.pageData.phone;
  },
  methods: {
    validateOTP(value) {
      this.otp = value;
      this.validateInput();
    },
    validateInput() {
      this.login();
      // this.$emit("stepper", {
      //   winStep: 0,
      // });
    },
    login() {
      this.appLoading = true;
      var userData = {};
      userData["phone"] = this.pageData.phone;
      if (this.loginWithPassword) {
        userData["password"] = this.password;
      } else {
        userData["otp"] = this.otp;
      }
      userData["guestid"] = localStorage.getItem("guestId");
      axios({
        method: "POST",
        url: "/user/weblogin",
        data: userData,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            localStorage.setItem("token", response.data.data.token);
            localStorage.removeItem("guestId");
            this.$store.commit("changeCart", response.data.cartcount);
            this.$store.commit("changeWishlist", response.data.wishlistcount);
            this.$store.commit("userData", response.data.userdata);
            this.$store.commit("loginUser", response.data.status);
            this.$store.commit("userType", response.data.data.type);
            if (localStorage.getItem("routeKey") && response.data.data.type == "Client") {
              // console.log("fullpath",localStorage.getItem("routeKey"))
              this.$router.push(localStorage.getItem("routeKey"));
            } else if (response.data.data.type == "Seller") {
              if (
                response.data.data.status == "Pending" &&
                response.data.userdata.seller.accountnumber == undefined
              ) {
                this.$router.push("/sellerRegistration");
              } else if (
                response.data.data.status == "Pending" &&
                response.data.userdata.seller.accountnumber != null
              ) {
                this.$router.push({ name: "sellerStatus" });
              } else if (response.data.data.status == "Rejected") {
                this.$router.push({ name: "sellerStatus" });
              } else {
                this.$router.push("/Seller");
              }
            } else if (response.data.data.type == "Client") {
              this.$router.push("/");
            } else {
              this.$router.push("/");
            }
          } else {
            this.msg2 = response.data.msg;
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    sentOTP() {
      var userData = {};
      userData["phone"] = this.pageData.phone;
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/getsms",
        data: userData,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.setTime(180);
            this.otpexpired = false;
            this.msg = "OTP Sent Successfully";
            this.showSnackBar = true;
          } else {
            this.msg = "Something Went Wrong";
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    setTime(seconds) {
      clearInterval(this.intervalTimer);
      this.timer(seconds);
    },
    timer(seconds) {
      const now = Date.now();
      const end = now + seconds * 1000;
      this.displayTimeLeft(seconds);
      this.countdown(end);
    },
    countdown(end) {
      this.intervalTimer = setInterval(() => {
        const secondsLeft = Math.round((end - Date.now()) / 1000);
        if (secondsLeft == 0) this.otpexpired = true;
        if (secondsLeft < 0) {
          clearInterval(this.intervalTimer);
          return;
        }
        this.displayTimeLeft(secondsLeft);
      }, 1000);
    },
    displayTimeLeft(secondsLeft) {
    const minutes = Math.floor((secondsLeft % 3600) / 60);
      const seconds = secondsLeft % 60;
      var seconds1 = seconds;
      if (seconds < 10) seconds1 = "0" + seconds;
      this.timeLeft = "0" + minutes + " : " + seconds1;
    },
  },
};
</script>